// theme.tsx
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none", // Isso removerá a sombra/borda preta no hover do botão
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderWith: "2px",
              borderColor: "#2D5BFF",
            },
          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderWith: "2px",
            borderColor: "#2D5BFF",
          },
          "&.Mui-focused fieldset": {
            borderWith: "2px",
            borderColor: "#2D5BFF !important",
          },
        },
      },
    },
    // Adicione outras personalizações aqui para outros componentes MUI
  },
});

export default theme;
